import React from 'react';
import ReactDOM from 'react-dom';
import { CustomProvider } from 'rsuite';

import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router } from 'react-router-dom';
import { AuthContextProvider } from './contexts/authContext';

ReactDOM.render(
  <React.StrictMode>
    <CustomProvider theme="dark">
      <AuthContextProvider>
        <Router>
          <App/>
        </Router>
      </AuthContextProvider>
    </CustomProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
